import type { ProductSummary } from "@/common/productSummary/types";

/** Normalize level and similar fields for search-bar product customDimensions. */
export function formatAnalyticsListField(val: unknown): string {
  if (val == null || val === "") return "";
  if (Array.isArray(val))
    return val
      .filter((x) => x != null && x !== "")
      .map(String)
      .join(", ");
  return String(val);
}

function joinUniqueSkillNames(names: (string | undefined)[]): string {
  return [...new Set(names.filter(Boolean) as string[])].join(", ");
}

/**
 * Skills string for Tagular customDimensions (deduped; shared Algolia + summaries).
 */
export function formatAnalyticsSkillsDisplay(
  skills?: string[] | null,
  skillsData?: { skill?: string }[] | null,
): string {
  if (skills?.length) return joinUniqueSkillNames(skills);
  if (skillsData?.length)
    return joinUniqueSkillNames(skillsData.map((s) => s.skill));
  return "";
}

export function analyticsSkillsFromAlgoliaHit(
  hit: Record<string, unknown>,
): string {
  return formatAnalyticsSkillsDisplay(
    hit.skills as string[] | undefined,
    hit.skillsData as { skill?: string }[] | undefined,
  );
}

export function analyticsSkillsFromProductSummary(
  product: ProductSummary,
): string {
  return formatAnalyticsSkillsDisplay(
    product.skills ?? undefined,
    product.skillsData ?? undefined,
  );
}

/** duration customDimension — weeks label as shown on cards. */
export function formatAnalyticsDurationWeeks(
  weeks: number | null | undefined,
): string | undefined {
  return weeks != null ? `${weeks} weeks` : undefined;
}
